<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-md-2">
            <div class="col-sm-12 col-lg-6 mb-1">
              <div class="dataTables_length" id="tickets-table_length">
                <label class="d-inline-flex align-items-center">
                  Afișează
                  <select
                    name="tickets-table_length"
                    aria-controls="tickets-table"
                    name="pageSize"
                    [(ngModel)]="adeverintaApiaService.pageSize"
                    [disabled]="loadingDataSpinner"
                    (change)="changePageSize($event)"
                    class="custom-select custom-select-sm form-control form-control-sm mx-2"
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  intrări
                </label>
              </div>
            </div>

            <!-- Search -->
            <div class="col-sm-12 col-lg-6">
              <div
                id="tickets-table_filter"
                class="d-flex justify-content-end"
              >
                <button
                  *ngIf="!isFermier"
                  class="btn btn-info btn-sm"
                  type="button"
                  placement="left"
                  [disabled]="loadingDataSpinner"
                  (click)="clickSearchModal()"
                >
                  <span class="mdi mdi-magnify"></span>
                  Căutare
                </button>

                <button
                  class="btn btn-blue btn-sm"
                  type="button"
                  (click)="openAddAdeverintaModal('add')"
                  [disabled]="loadingDataSpinner"
                >
                  <span class="mdi mdi-plus-circle"></span>
                  Crează adeverință
                </button>

                <button
                  *ngIf="isAdmin || isOperator"
                  class="btn btn-success btn-sm"
                  type="button"
                  (click)="export()"
                  [disabled]="loadingDataSpinner"
                  ngbTooltip="Se vor exporta doar datele afișate"
                  placement="bottom"
                >
                  <i class="mdi mdi-file-excel"></i>
                  Exportă XLS
                </button>
              </div>
            </div>
            <!-- End search -->
          </div>

          <div
            class="spinner-border text-info table-spinner avatar-lg"
            role="status"
            *ngIf="loadingDataSpinner"
          ></div>

          <!-- Table -->
          <div class="table-responsive" #adeverinteApartenentaTable>
            <table
              id="adeverinte-datatable"
              class="table datatables dt-responsive nowrap table-hover"
            >
              <thead>
                <tr>
                  <th sortable="cod_exploatatie" (sort)="onSort($event)">
                    Cod exploatație
                  </th>
                  <th sortable="nume_exploatatie" (sort)="onSort($event)">
                    Nume exploatație
                  </th>
                  <th sortable="numar" (sort)="onSort($event)">
                    Număr
                  </th>
                  <th sortable="data" (sort)="onSort($event)">
                    Data
                  </th>
                  <th sortable="status" (sort)="onSort($event)">
                    Status
                  </th>
                  <th sortable="autor" (sort)="onSort($event)">
                    Autor
                  </th>
                  <th scope="col">
                    Acțiuni
                  </th>
                </tr>
              </thead>

              <tbody [ngClass]="{ disabled: loadingDataSpinner }">
                <tr *ngFor="let adeverinta of listaAdeverinte">
                  <td>{{ adeverinta.cod_exploatatie }}</td>
                  <td>
                    <a
                      [routerLink]="'/dashboard/exploatatie/' + adeverinta.cod_exploatatie +'/animale-exploatatie'"
                      target="_blank"
                    > {{ adeverinta.nume_exploatatie }}
                    </a>
                  </td>
                  <td>
                    <input
                      type="number"
                      class="form-control read-only-form w10"
                      [readonly]="isFermier || (!isSuperAdmin && adeverinta.status != 1)"
                      (change)="adeverinta.numar = $event.target.value"
                      [value]="adeverinta.numar"
                    />
                  </td>
                  <td>
                    <div>
                      <app-date-picker
                        [selectedDate]="adeverinta.data"
                        (dateChanged)="adeverinta.data = $event"
                        [disabled]="isFermier || (!isSuperAdmin && adeverinta.status != 1)"
                      ></app-date-picker>
                    </div>
                  </td>
                  <td>{{ adeverinta.status_text }}</td>
                  <td>{{ adeverinta.nume_autor }}</td>

                  <td class="action-buttons">
                    <div class="btn-group">

                      <button
                        class="btn btn-sm btn-success"
                        (click)="downloadAdeverinta($event, adeverinta)"
                      >
                        Descarcă
                      </button>

                      <button
                        *ngIf="isSuperAdmin || ((isAdmin || isOperator) && adeverinta.status == 1)"
                        class="btn btn-sm btn-info"
                        (click)="salveazaNumarData(adeverinta)"
                      >
                        Salvează
                      </button>

                      <button
                        *ngIf="isSuperAdmin || ((isAdmin || isOperator) && adeverinta.status == 1)
                          || (isFermier && adeverinta.status == 1 && userId == adeverinta.autor_id)
                        "
                        class="btn btn-sm btn-blue"
                        (click)="editeaza(adeverinta)"
                      >
                        Editează
                      </button>

                      <button
                        *ngIf="(isAdmin || isOperator) && adeverinta.status == 1"
                        class="btn btn-sm btn-primary"
                        [ngClass]="'finalizeaza-id-' + adeverinta.id"
                        (click)="openFinalizeazaModal(adeverinta.id)"
                      >
                        Finalizează
                      </button>

                      <button
                        *ngIf="(isAdmin || isOperator) && adeverinta.status == 2"
                        class="btn btn-sm btn-danger"
                        [ngClass]="'anuleaza-id-' + adeverinta.id"
                        (click)="openAnuleazaModal(adeverinta.id)"
                      >
                        Anulează
                      </button>

                      <button
                        *ngIf="isSuperAdmin || ((isAdmin || isOperator) && adeverinta.status == 1)
                          || (isFermier && adeverinta.status == 1 && userId == adeverinta.autor_id)
                        "
                        class="btn btn-sm btn-danger"
                        [ngClass]="'sterge-id-' + adeverinta.id"
                        (click)="openDeleteModal(adeverinta.id)"
                      >
                        Șterge
                      </button>

                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <ngb-alert
              type="danger"
              class="text-center search-error"
              *ngIf="!loadingDataSpinner && adeverintaApiaService.totalRecords === 0"
              [dismissible]="false"
            >
              Nu există înregistrări
            </ngb-alert>

          </div>
          <!-- End table -->
          <div
            class="row justify-content-lg-between align-items-lg-center mt-2"
            *ngIf="adeverintaApiaService.totalRecords > 0"
          >
            <div class="col-sm-12 col-lg-6">
              <div
                class="dataTables_info mb-2"
                id="tickets-table_info"
                role="status"
                aria-live="polite"
              >
                Afișează de la
                {{ adeverintaApiaService.startIndex }} la
                {{ adeverintaApiaService.endIndex }} din
                {{ adeverintaApiaService.totalRecords }}
                intrări
              </div>
            </div>
            <!-- Pagination -->
            <div class="col-sm-12 col-lg-6">
              <div class="text-lg-right float-lg-right pagination-rounded">
                <ngb-pagination
                  [disabled]="loadingDataSpinner"
                  [collectionSize]="numarAdeverinte"
                  [(page)]="adeverintaApiaService.page"
                  [pageSize]="adeverintaApiaService.pageSize"
                  [maxSize]="5"
                  (pageChange)="changePageNumber($event)"
                >
                </ngb-pagination>
              </div>
            </div>
            <!-- End Pagination -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-add-edit-adeverinta-apia
  [addEditModalType]="addEditModalType"
  [addEditModalData]="addEditModalData"
  (notifyClose)="closeAddEditModal($event)"
>
</app-add-edit-adeverinta-apia>


<ng-template #searchModal let-modal="close">
  <div class="modal-header">
    <h3 class="modal-title">
      Caută Adeverințe APIA
    </h3>

    <button
      type="button"
      class="close"
      aria-hidden="true"
      (click)="modal('Cross click')"
    >
      ×
    </button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <form [formGroup]="AdeverintaAPIAForm">

        <div class="row">
          <div class="col-sm-12 col-md-6">
              <div class="form-group mb-3">
                  <label for="start_date">
                      Dată început
                  </label>
                  <app-date-picker
                    [selectedDate]="AdeverintaAPIAForm.controls.start_date.value"
                    (dateChanged)="onStartDateChanged($event)">
                  </app-date-picker>
              </div>
          </div>

          <div class="col-sm-12 col-md-6">
              <div class="form-group mb-3">
                  <label for="end_date">
                      Dată sfârșit
                  </label>
                  <app-date-picker
                    [selectedDate]="AdeverintaAPIAForm.controls.end_date.value"
                    (dateChanged)="onEndDateChanged($event)">
                  </app-date-picker>
              </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div class="form-group mb-3">
              <label for="company_name">
                Denumirea exploatației
              </label>

              <input
                type="text"
                id="company_name"
                formControlName="company_name"
                placeholder="Adaugă denumirea exploatației"
                class="form-control w-100" />
            </div>
          </div>

          <div class="col-sm-12 col-md-6">
            <div class="form-group mb-3">
              <label for="company_code">
                Codul exploatației
              </label>

              <input
                type="text"
                id="company_code"
                formControlName="company_code"
                placeholder="Adaugă codul exploatației"
                class="form-control w-100" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
              <div class="form-group mb-3">
                  <label for="rasa">
                      Rasă
                  </label>
                  <ng-select formControlName="rasa" placeholder="Toate">
                      <ng-option value='Charolaise'>Charolaise</ng-option>
                      <ng-option value='Limousine'>Limousine</ng-option>
                  </ng-select>
              </div>
          </div>

          <div class="col-sm-12 col-md-6">
            <div class="form-group mb-3">
                <label for="status">
                    Status
                </label>
                <ng-select formControlName="status" placeholder="Toate">
                    <ng-option value='1'>Salvată</ng-option>
                    <ng-option value='2'>Finalizată</ng-option>
                    <ng-option value='3'>Anulată</ng-option>
                </ng-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7 text-nowrap">
            <div class="btn-group">
              <button
                class="btn btn-sm btn-blue"
                (click)="cauta(); modal('Cross click')"
              >
                <span class="mdi mdi-magnify"></span>
                Caută
              </button>
              <button
                class="btn btn-sm btn-warning"
                (click)="resetFields()"
              >
                Resetează câmpurile
              </button>
            </div>
          </div>

          <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5 text-nowrap text-right">
            <button class="btn btn-sm btn-danger" (click)="resetSearch(); modal('Cross click')">
              Resetează căutarea
            </button>
          </div>
        </div>

      </form>

    </div>
  </div>
</ng-template>


<app-confirm-action-modal
  [open]="openDelete"
  [text]="'Șterge Adeverința APIA?'"
  (confirm)="closeDeleteModal($event)"
></app-confirm-action-modal>


<app-confirm-action-modal
  [open]="openFinalizeaza"
  [text]="'Finalizează Adeverința APIA?'"
  (confirm)="closeFinalizeazaModal($event)"
></app-confirm-action-modal>


<app-confirm-action-modal
  [open]="openAnuleaza"
  [text]="'Anulează Adeverința APIA?'"
  (confirm)="closeAnuleazaModal($event)"
></app-confirm-action-modal>
